/**
 * The single realm role that grants access to this application.
 *
 * Matches the role already enforced across the Viana platform — see
 * `viana-superadmin-portal/src/App.tsx` and `viana-services/routes/index.js`
 * (`keycloak.protect('realm:GodLike')`).
 */
export const GODLIKE_ROLE = 'GodLike';
export function hasGodLike(roles) {
    return Boolean(roles?.includes(GODLIKE_ROLE));
}
//# sourceMappingURL=auth.js.map